import { provideAppInitializer, inject } from '@angular/core';
import { TranslationService } from './translation.service';
import fr from '../../../../public/i18n/fr.json';
import en from '../../../../public/i18n/en.json';

export function provideTranslations() {
  return provideAppInitializer(() => {
    const translationService = inject(TranslationService);
    translationService.loadTranslations('fr', fr);
    translationService.loadTranslations('en', en);
  });
}
